import { useMemo } from "react";

import { useGetAllUsersRolesQuery } from "@/api/admin/roleManagment";
import { UserLevel } from "@/api/admin/users";

export interface GroupedRole {
  level: UserLevel | string;
  roles: {
    id: string;
    name: string;
    active?: boolean;
  }[];
}

export const useGroupedRoles = () => {
  const { data: usersRoleDatas, isPending: isRolePending } =
    useGetAllUsersRolesQuery({ limit: 100, offset: 0 });

  const groupedRoles = useMemo(() => {
    if (!usersRoleDatas?.items) return [];

    const grouped = usersRoleDatas.items.reduce(
      (acc, item) => {
        if (!item.active) return acc;

        if (!acc[item.level]) {
          acc[item.level] = {
            level: item.level,
            roles: [],
          };
        }
        acc[item.level].roles.push({
          id: item.id,
          name: item.name,
        });
        return acc;
      },
      {} as Record<string, GroupedRole>
    );

    return Object.values(grouped);
  }, [usersRoleDatas?.items]);

  return {
    groupedRoles,
    isRolePending,
    usersRoleDatas: usersRoleDatas?.items,
  };
};
